// extracted by mini-css-extract-plugin
module.exports = {"specTable":"Specification_specTable__vkHVE","onDetails":"Specification_onDetails__kntop"};